import { selectLayoutById } from '../../selectors/layoutsCatalog';
import type * as React from 'react';
import { useSelector } from 'react-redux';
import { LayoutCardWrapper } from '../../components/LayoutCard';
import { Gallery } from '../Gallery';
import { Builder } from '../Builder';
import { Building } from '../Building';
import { CardContext } from '../../utils/cardContext';

interface ILayoutCardProps {
  id: number;
}

export const LayoutCard = ({ id }: ILayoutCardProps): React.JSX.Element => {
  const layout = useSelector(selectLayoutById(id));

  return (
    <CardContext.Provider value={layout}>
      <LayoutCardWrapper gallery={<Gallery />} builder={<Builder />} building={<Building />} />
    </CardContext.Provider>
  );
};
